import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center justify-end" }

import { computed, PropType, ref, watch } from "vue";
  import { QInput } from "quasar";

  import { useAge } from "src/functions";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DobInput',
  props: {
    modelValue: {
      type: Object as PropType<Date | null>,
      default: null,
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const rules = computed(() => [
    (val: string) => (props.required && !!val) || !props.required || "Required",
    (val: string) => (val && dateValid(val)) || (!val && !props.required) || "Invalid Date",
    (val: string) => (new Date().getFullYear() - new Date(val.split("/").reverse().join("/")).getFullYear() < 100) || (!val && !props.required) || "Must be less than 100 years old",
    (val: string) => (useAge(new Date(val.split("/").reverse().join("/"))) >= 18) || (!val && !props.required) || "Must be 18 or older"
  ])

  const value = computed<Date | null>({
    get() {
      return props.modelValue ?? null
    },
    set(value: Date | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit
  
  
  const dobInputRef = ref<QInput | null>(null);
  function validate() {
    return dobInputRef.value!.validate();
  }
  __expose({
    validate
  })

  function blurValidate() {
    setTimeout(() => {
      dobInputRef.value!.blur();
      dobInputRef.value!.validate();
    }, 1)
  }

  const dateString = ref("");
  watch(dateString, () => {
    if (!dateString.value || dateString.value === '') {
      emit('update:modelValue', null);
      return;
    }
    emit('update:modelValue', new Date(Number(dateString.value.split("/")[2]), Number(dateString.value.split("/")[1]) - 1, Number(dateString.value.split("/")[0])))
  })

  function dateValid(val: string) {
    const d = new Date(val.split("/").reverse().join("/"))
    return d.toString() !== 'Invalid Date' ? true : false
  }


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QInput), {
      outlined: "",
      dense: "",
      modelValue: dateString.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateString).value = $event)),
      ref_key: "dobInputRef",
      ref: dobInputRef,
      "data-cy": "dobInput",
      pattern: "[0-9]",
      rules: rules.value,
      "lazy-rules": "",
      mask: "##/##/####",
      class: "tw-shadow-sm",
      locale: "en-GB",
      "data-clarity-unmask": "true"
    }, {
      append: _withCtx(() => [
        _createVNode(_component_q_icon, {
          name: "event",
          size: "xs",
          class: "cursor-pointer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_popup_proxy, {
              cover: "",
              "transition-show": "scale",
              "transition-hide": "scale"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_date, {
                  modelValue: dateString.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((dateString).value = $event)),
                    blurValidate
                  ],
                  mask: "DD/MM/YYYY"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _withDirectives(_createVNode(_component_q_btn, {
                        label: "Close",
                        color: "primary",
                        flat: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "rules"])
  ], 64))
}
}

})